import { Helmet } from 'react-helmet-async'
import ContactUsComponent from '../../components/ContactUsComponent'

const companyStory = [
  {
    heading: "Our Mission",
    desc: "We help businesses achieve their digital goals by providing reliable software solutions that empower growth and innovation."
  },
  {
    heading: "Our Vision",
    desc: "To become a global technology partner recognized for quality, innovation, and excellence in software development."
  },
  {
    heading: "Our Values",
    desc: "Integrity, creativity, collaboration, and commitment to delivering high-quality solutions that make a difference."
  }
]

const services = [
  {
    icon: "../images/fill-color.png",
    name: "Web & Mobile Development",
    desc: "Crafting scalable and interactive web and mobile applications that meet your business needs."
  },
  {
    icon: "../images/talk.png",
    name: "IT Consulting",
    desc: "Providing expert guidance on leveraging technology to optimize your business processes."
  },
  {
    icon: "../images/earth-globe.png",
    name: "Extended Team",
    desc: "Seamlessly extending your team with skilled developers and specialists as per your requirements."
  }
]

const technologiesIcon = [
  "../images/react.png",
  "../images/nodejs.png",
  "../images/laravel.png",
  "../images/python.png",
  "../images/aws.png",
  "../images/mongodb.png",
  "../images/vue.png",
  "../images/docker.png",
]


const WhyUs = () => {

  return (
    <div className="bg-white w-full flex flex-col overflow-hidden">
      <Helmet>
        <title>Data Repo | Why Choose Our Software Development & AI Team</title>
        <meta
          name="description"
          content="Discover why businesses choose Data Repo for software development, AI solutions, and digital innovation. Learn about our mission, values, services, and technology expertise."
        />
      </Helmet>

      <section className="relative w-full h-[50vh] md:h-[70vh] flex flex-col justify-center items-center bg-gradient-to-r from-slate-600 via-slate-500 to-slate-400 overflow-hidden">

        <div className="absolute top-0 left-0 w-64 h-64 bg-indigo-500 rounded-full opacity-20 animate-pulse-slow"></div>
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-pink-500 rounded-full opacity-20 animate-pulse-slow delay-200"></div>
        <div className="absolute top-1/3 left-1/2 w-96 h-96 bg-yellow-400 rounded-full opacity-10 -translate-x-1/2 animate-pulse-slow delay-400"></div>

        <div className="relative z-10 flex flex-col items-center text-center px-4 md:px-16 max-w-4xl">
          <h1 className="text-white text-4xl md:text-5xl font-extrabold mb-6 animate-slide-up">
            Why Choose Data Repo for Software Development & AI Solutions
          </h1>
          <p className="text-white text-lg md:text-2xl font-semibold mb-8 animate-fade-in">
            We turn ideas into digital reality with innovative, scalable technology solutions.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-16 py-10 text-center max-w-4xl mx-auto">
        <p className="text-lg text-gray-700">
          Data Repo is a trusted technology partner specializing in custom software development,
          AI-powered solutions, and scalable digital products. Our team combines innovation,
          engineering excellence, and strategic thinking to deliver measurable business impact.
        </p>
      </section>

      <section className="flex flex-col items-center py-16 px-8 md:px-16 lg:px-24 bg-gray-50">
        <div className="max-w-4xl flex flex-col gap-12">
          {companyStory.map((item, index) => (
            <div key={index}>
              <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">{item.heading} at Data Repo</h2>
              <p className="text-lg md:text-xl text-gray-700">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="flex flex-col items-center py-16 px-8 md:px-16 lg:px-24">
        <h2 className="text-4xl font-bold text-black mb-12">Our Software Development & IT Consulting Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center p-6 rounded-lg shadow-lg hover:shadow-2xl transition">
              <img src={item.icon} alt={`${item.name} service icon`} className="w-12 h-12 mb-4" />
              <h3 className="text-2xl font-semibold mb-2">{item.name}</h3>
              <p className="text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="flex flex-col items-center py-16 px-8 md:px-16 lg:px-24 bg-gray-50">
        <h2 className="text-4xl font-bold text-black mb-12">Technologies Powering Our Software Solutions</h2>
        <div className="flex flex-wrap justify-center gap-8">
          {technologiesIcon.map((item, index) => (
            <img key={index} src={item} alt={`${item.split("/").pop()?.replace('.png', '')} technology`} className="w-24 h-24 object-contain" />
          ))}
        </div>
      </section>

      <ContactUsComponent />

    </div>
  )
}

export default WhyUs;